import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
    const navigate = useNavigate();

    // Redirect to /cards for now
    useEffect(() => {
        navigate("/cards", { replace: true });
    }, [navigate]);

    return <></>;
}
